export default __webpack_public_path__ + "static/media/closet5-after3-1024w.fe3c3426.webp";